import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from 'i18next';
import '../../styles/widgets/popup/numberChartGame.scss';
import RadioButton from '../../components/RadioButton';
import CustomScrollbar from '../../components/CustomScrollbar';
import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../../player/DataContext';
import customEventHandler from '../../helper/customEvents';
import FooterActionsButtons from './FooterActionsButtons';
// Maps game name to radioIdx and shapeIdx
var getIndicesFromGameName = function (gameName) {
    if (!gameName)
        return { radioIdx: 0, shapeIdx: undefined };
    var gameToIndices = {
        MissingNumber: { radioIdx: 0 },
        OneMoreOneLess: { radioIdx: 1 },
        Line: { radioIdx: 2 },
        Square: { radioIdx: 3, shapeIdx: 0 },
        Circle: { radioIdx: 3, shapeIdx: 1 },
        HShape: { radioIdx: 3, shapeIdx: 2 },
        TShape: { radioIdx: 3, shapeIdx: 3 },
        PlusShape: { radioIdx: 3, shapeIdx: 4 },
    };
    var indices = gameToIndices[gameName];
    return indices
        ? { radioIdx: indices.radioIdx, shapeIdx: indices.shapeIdx }
        : { radioIdx: 0, shapeIdx: undefined };
};
var NumberChartGame = function () {
    var _a;
    var RADIO_OPTS = [
        t('text.missingNumber'),
        t('text.oneMoreOneLess'),
        t('text.line'),
        t('text.patterns'),
    ];
    var RADIO_SHAPES_OPTS = [
        './assets/images/manipulative/numberChart/square.svg',
        './assets/images/manipulative/numberChart/circle.svg',
        './assets/images/manipulative/numberChart/hShape.svg',
        './assets/images/manipulative/numberChart/tShape.svg',
        './assets/images/manipulative/numberChart/plusShape.svg',
    ];
    var RADIO_SHAPES_OPTS_DISABLE = [
        './assets/images/manipulative/numberChart/squareD.svg',
        './assets/images/manipulative/numberChart/circleD.svg',
        './assets/images/manipulative/numberChart/hShapeD.svg',
        './assets/images/manipulative/numberChart/tShapeD.svg',
        './assets/images/manipulative/numberChart/plusShapeD.svg',
    ];
    var _b = useContext(DataContext), setSelectedManipulativeId = _b.setSelectedManipulativeId, setManiplulatorComponentVisible = _b.setManiplulatorComponentVisible, setActiveManipulator = _b.setActiveManipulator, selectedManipulativeId = _b.selectedManipulativeId, selectedTool = _b.selectedTool, manipulative = _b.manipulative;
    // Get current game settings from manipulative data
    var selectedManipulative = manipulative.find(function (item) { return item.data.id === selectedTool[0]; });
    var chartData = selectedManipulative === null || selectedManipulative === void 0 ? void 0 : selectedManipulative.data;
    var initialIndices = getIndicesFromGameName((_a = chartData === null || chartData === void 0 ? void 0 : chartData.currentGame) !== null && _a !== void 0 ? _a : null);
    var _c = useState((chartData === null || chartData === void 0 ? void 0 : chartData.isGameMode) ? initialIndices.radioIdx : 0), radioIdx = _c[0], setRadioIdx = _c[1];
    var _d = useState((chartData === null || chartData === void 0 ? void 0 : chartData.isGameMode) ? initialIndices.shapeIdx : undefined), shapeIdx = _d[0], setShapeIdx = _d[1];
    var _e = useState(true), disablePattern = _e[0], setDisablePattern = _e[1];
    // Update radio selection when popup opens with different manipulative
    useEffect(function () {
        if ((chartData === null || chartData === void 0 ? void 0 : chartData.isGameMode) && (chartData === null || chartData === void 0 ? void 0 : chartData.currentGame)) {
            var _a = getIndicesFromGameName(chartData.currentGame), newRadioIdx = _a.radioIdx, newShapeIdx = _a.shapeIdx;
            setRadioIdx(newRadioIdx);
            setShapeIdx(newShapeIdx);
        }
    }, [selectedManipulativeId]);
    useEffect(function () {
        if (radioIdx !== 3) {
            setDisablePattern(true);
        }
        else {
            setDisablePattern(false);
        }
    }, [radioIdx]);
    var onRadioChange = function (value, type) {
        if (type === 'method') {
            setRadioIdx(value);
            setShapeIdx(undefined);
            if (value === 3) {
                setShapeIdx(0);
            }
        }
        else {
            setRadioIdx(3);
            setShapeIdx(value);
        }
    };
    var shapeName = function (radioIdx, shapeIdx) {
        var _a;
        var radioMap = {
            1: 'OneMoreOneLess',
            2: 'Line',
        };
        var shapeMap = {
            0: 'Square',
            1: 'Circle',
            2: 'HShape',
            3: 'TShape',
            4: 'PlusShape',
        };
        if (radioIdx === 3) {
            return shapeMap[shapeIdx !== null && shapeIdx !== void 0 ? shapeIdx : 4];
        }
        return (_a = radioMap[radioIdx]) !== null && _a !== void 0 ? _a : 'MissingNumber';
    };
    var onBtnClick = function (type) {
        var _a;
        if (type === 'done') {
            customEventHandler.dispatchEvent('numberChartGame', {
                id: 'numberChartGame',
                val: selectedManipulativeId,
                shapeType: shapeName(radioIdx, shapeIdx),
            });
        }
        var focusId = (_a = selectedTool[0]) !== null && _a !== void 0 ? _a : selectedManipulativeId;
        setSelectedManipulativeId('');
        setManiplulatorComponentVisible(false);
        setActiveManipulator('');
        // Focus the number chart on canvas after popup closes
        if (focusId) {
            setTimeout(function () {
                var _a;
                var wrapper = document.querySelector("[data-manipulative-id=\"".concat(focusId, "\"]"));
                var gridBtn = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.gridParent');
                (_a = (gridBtn !== null && gridBtn !== void 0 ? gridBtn : wrapper)) === null || _a === void 0 ? void 0 : _a.focus();
            }, 200);
        }
    };
    return (_jsx("div", { className: "numberChartGameWrapper", onKeyDown: function (e) {
            if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                e.stopPropagation();
            }
        }, children: _jsxs("div", { className: "holder", children: [_jsxs(CustomScrollbar, { direction: "vertical", tabIndex: -1, children: [_jsxs("div", { className: "upperContainer", children: [_jsxs("fieldset", { className: "radioFieldset", children: [_jsx("legend", { className: "sronly", children: t('text.gameType') }), _jsx(RadioButton, { id: "numCharts-type", options: RADIO_OPTS, selected: radioIdx, onChange: function (value) { return onRadioChange(value, 'method'); }, className: "radioGap" })] }), _jsx("hr", { className: "divider", "aria-hidden": "true" })] }), _jsx("div", { className: "shapeWrapper", children: _jsxs("fieldset", { className: "radioFieldsetDirection", children: [_jsx("legend", { className: "sronly", children: t('text.patternShape') }), _jsx(RadioButton, { id: "direction", options: disablePattern ? RADIO_SHAPES_OPTS_DISABLE : RADIO_SHAPES_OPTS, selected: shapeIdx, onChange: function (value) { return onRadioChange(value, 'shape'); }, className: "radioGap", optionsType: "image", disabled: disablePattern, ariaLabels: [
                                            t('text.squareShape'),
                                            t('text.circleShape'),
                                            t('text.hShape'),
                                            t('text.tShape'),
                                            t('text.plusShape'),
                                        ], useAriaLabelFromOutside: true })] }) }), _jsx("div", { className: "text", children: t('text.numberChartRevealHint') })] }), _jsx(FooterActionsButtons
                // disableDoneBtn={isRowColInvalid || isStartValueLengthInvalid}
                , { 
                    // disableDoneBtn={isRowColInvalid || isStartValueLengthInvalid}
                    onActionBtnClick: function (type) {
                        onBtnClick(type);
                    } })] }) }));
};
export default NumberChartGame;
